import { useQuery } from "@tanstack/react-query";
import { getCollectorStatus } from "src/api/collectorStatus/getCollectorStatus";
import { CollectorStatus } from "./types";
import { QueryClientScope } from "../types";
import { getEnv } from "src/config/index";
import { useFeatureToggle } from "src/api/featureToggling/useGetFeatureToggle";
import { FeatureToggleKey } from "src/api";
import { getServices } from "src/logs";

const { logger } = getServices();

const refreshInterval =
getEnv().REACT_APP_BE_REFRESH_INTERVAL ||
  (() => {
    logger.logError({message : "REACT_APP_BE_REFRESH_INTERVAL environmental variable not set"});
    throw new Error("REACT_APP_BE_REFRESH_INTERVAL environmental variable not set");
  })();

export const useGetCollectorStatus = (date: string) => {
  const { data : logsDetailedFeature} = useFeatureToggle(FeatureToggleKey.LogsDetailed);
  return useQuery<CollectorStatus, Error>({
    queryKey: [QueryClientScope.CollectorStatus],
    queryFn: () => getCollectorStatus(date, logsDetailedFeature?.isEnabled),
    refetchOnWindowFocus: false,
    retry: 3,
    retryDelay: 3000,
    staleTime: 5 * 60 * 1000,
    refetchInterval: parseInt(refreshInterval),
  });
};
